export default __webpack_public_path__ + "static/media/Software-Papel-Comercial.b4020af0.png";